/* eslint-disable no-nested-ternary */
/* eslint-disable react/require-default-props */
import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import countries from 'services/constants/countries-new.json';

export type TCountryWithFlagProps = {
	countryCode?: string;
	countryName?: string;
	size?: 'small' | 'medium' | 'large';
	sx?: {
		[key: string]: string | number;
	};
	bold?: boolean;
	color?: string;
};

export const CountryWithFlag: FC<TCountryWithFlagProps> = ({
	countryCode,
	countryName,
	size = 'medium',
	sx = {},
	bold = false,
	color,
}) => {
	const country = countryCode
		? countries?.find?.((cntr) => cntr?.code === countryCode)
		: countryName
			? countries?.find?.((cntr) => cntr?.label === countryName)
			: null;
	if (!country) return null;
	const countryCodeFlag =
		countryCode === 'XI' ? 'gb' : countryCode === 'EL' ? 'gr' : country?.code?.toLowerCase();
	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				gap: 1,
			}}
		>
			<img
				loading="lazy"
				height="12"
				srcSet={`/img/w40/${countryCodeFlag}.png 2x`}
				src={`/img/w20/${countryCodeFlag}.png`}
				alt=""
			/>
			<Typography
				// variant="body1"
				sx={{
					...sx,
					fontSize: size === 'small' ? '.875rem' : 'auto',
					fontWeight: bold ? 'bold' : 'normal',
				}}
				color={color}
			>
				{country?.label ?? countryCode}
			</Typography>
		</Box>
	);
};
